import PageWithHeaderLayout from '@/app/layouts/PageWithHeader.layout';

import LoginContent from './LoginContent';

const LoginPage = () => (
	<PageWithHeaderLayout showBackButton>
		<LoginContent />
	</PageWithHeaderLayout>
);

export default LoginPage;
